/* eslint-disable no-undef */
import firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/database";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAngH9KUqzK64-SQNU1RsQfXSWr9eT-cXg",
  authDomain: "nova-4bfb4.firebaseapp.com",
  databaseURL:
    "https://nova-4bfb4-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "nova-4bfb4",
  storageBucket: "nova-4bfb4.appspot.com",
  messagingSenderId: "212524049320",
  appId: "1:212524049320:web:89d48938e70b749620339d",
};

firebase.initializeApp(firebaseConfig);

const useEmulator = false;

if (window.location.hostname === "localhost" && useEmulator) {
  firebase.functions().useEmulator("localhost", 5001);
  firebase
    .auth()
    .useEmulator("http://localhost:9099", { disableWarnings: true });
  firebase.firestore().useEmulator("localhost", 8080);
  firebase.storage().useEmulator("localhost", 9199);
}

export default firebase;
